import { StyleProps, IHeaderPanelProps } from '../../HeaderPanel';
import classNames from 'classnames';
import './Panels.less';
import { getFlexGridClasses } from 'components/flexgrid/flexgrid';

function getHeaderContainerClasses(type: string) {
  return classNames(`dp-entitydetails-container-${type}`);
}

const headerContainerRootStyle = (type: string): StyleProps => {
  return {
    className: `${getHeaderContainerClasses(type)}`,
  };
};

const headerContainerHeaderStyle = (type: string): StyleProps => {
  return {
    className: `${getHeaderContainerClasses(type)}__header`,
  };
};

const headerContainerBodyStyle = (type: string): StyleProps => {
  return {
    className: `${getHeaderContainerClasses(type)}__body`,
  };
};

const headerContainerTitleStyle = (type: string): StyleProps => {
  return {
    className: `${getHeaderContainerClasses(type)}__title`,
  };
};
export const headerPanelOptions = (type: string, title: string): IHeaderPanelProps => {
  return {
    title,
    rootStyle: headerContainerRootStyle(type),
    headerStyle: headerContainerHeaderStyle(type),
    bodyStyle: headerContainerBodyStyle(type),
    titleStyle: headerContainerTitleStyle(type),
    isCollapsible: true,
    isOpen: true,
  };
};

export function getDetailsItemClasses(detailsClassItem: string, isHeader: boolean) {
  return classNames(`${detailsClassItem}__item`, {
    [`${detailsClassItem}__item--header`]: isHeader,
  });
}

export function getPanelClasses(panelSide: string, xs: number, md: number) {
  return classNames(`dp-entitydetails__${panelSide}-panel`, {
    [getFlexGridClasses({ xs, md })]: !!xs && !!md,
  });
}
